module.exports = __webpack_public_path__ + "static/media/Eid-Card_02.a.204372b7.png";